import { createDrawerStore } from '../drawer/createDrawerStore';

/**
 * Stack-based Zustand store for the bilateral `Account` drawer.
 *
 * Stores only the `Account._id` of each entry; the actual document
 * comes from the React Query cache (`useAccountApi(id)`). Mounted
 * once at the app shell (e.g. `CRMWorkspacePage`) so any list/card
 * can call `useAccountDrawerStore().open(id)` to surface it.
 */
export const useAccountDrawerStore = createDrawerStore();
